// Series UIDs for the indoor climate chart. Extracted so the chart container
// and the external legend component can both depend on these without forming
// a circular import.
export enum IndoorClimateSeriesType {
  OUTDOOR_TEMP = "outdoor",
  AVERAGE_TEMP = "temp",
  AVERAGE_HUMID = "humid",
  FLEXSTATION_TEMP_MIN = "flex_temp_min",
  FLEXSTATION_TEMP_MAX = "flex_temp_max",
  FLEXSTATION_TEMP_RANGE = "flex_temp_range",
}

export type FlexstationTemperatureBound = {
  timestamp: string;
  min?: number | null;
  max?: number | null;
};
